import { useEffect } from "react";
import { initiateClassLinkSignIn } from "utils/classlinkAuth";

// Entry point for ClassLink LaunchPad tile-clicks. ClassLink's IdP-initiated
// flow expects a configurable "App Launch URL" on our side; the URL pointing
// at this component is registered with ClassLink so a tile click lands here.
// On mount we kick off the standard SP-init OAuth flow toward the educator
// dashboard — the user is already authenticated at ClassLink, so the
// authorize redirect comes back immediately with a code.
export const ClassLinkLaunchpadInitiate = () => {
  useEffect(() => {
    initiateClassLinkSignIn("/educator", { isEducator: true });
  }, []);

  return null;
};
